export default __webpack_public_path__ + "static/media/offre.c3812b4c.png";